import React, { useEffect, useState } from "react";
import header_icon from "../../../assets/temp/title_image.jpg";

import { useDispatch, useSelector } from "react-redux";
import CustomizedDialogs from "components/shared-components/messagenotification/successmessage";
import moment from "moment";
import { Button, Modal, Input, Select, Menu, Dropdown } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import { fetchAgreementByIdRequest, getAgreementByIdState, requestMoveInEmailSend, verifySmartSuiteAgreementRequest } from "redux/reducers/smartSuiteAgreement";
import ButtonWrapper from "components/shared-components/MaterialFormUI/Button";
import { logout } from "redux/reducers/loggedInUser";
import { getUserDetailData, getUserDetailsRequest } from "redux/reducers/manageUsers";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { API_BASE_URL } from "configs/AppConfig";
const BASE_URL = API_BASE_URL;
import axios from "axios";
const { Option } = Select;

const { TextArea } = Input;

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ApproveNotice = (props) => {

  const dispatch=useDispatch()
  const [ isModalVisible,setIsModalVisible]=useState(false);
  let checks  = localStorage.getItem("NoticeUrl")
// Your URL query string


const urlParams = new URLSearchParams(checks);
  //  console.log("urlParams",urlParams)
  const emailReceiver = urlParams.get("emailReceiver");
const lockInEndDate = urlParams.get("lockInEndDate");
const newTerminationDate = urlParams.get("newTerminationDate");
const noofSeats = urlParams.get("noofSeats");
const clientName = urlParams.get("clientName");
const businesCenter = urlParams.get("businesCenter");
const clientId = urlParams.get("clientId");
const actionedBy = urlParams.get("actionedBy");
const agreementId = urlParams.get("agreementId");
const Comment = urlParams.get("Comment");
const oldTerminationDate = urlParams.get("oldTerminationDate");
const initiatedBy = urlParams.get("initiatedBy");
//  console.log()
const CommentIndex = Comment?.indexOf('/');
//  console.log("Comment",Comment,CommentIndex)
 // Extract the desired part using substring
 var CommentdPart = Comment?.substring(0, CommentIndex);
const emailData = {"emailReceiver":emailReceiver,"lockInEndDate":lockInEndDate,"newTerminationDate":newTerminationDate, "oldTerminationDate": oldTerminationDate, "initiatedBy": initiatedBy,
  "noofSeats":noofSeats, "businesCenter":businesCenter,"clientId":clientId,"actionedBy":actionedBy,"clientName":clientName,"Comment":CommentdPart
 }
//  console.log("agreementId",agreementId)
 const questionMarkIndex = agreementId?.indexOf('/');
 // Extract the desired part using substring
 var desiredPart = agreementId?.substring(0, questionMarkIndex);
//  setTimeout(()=>{
   useEffect(()=>{
    const params = { id: agreementId };
     dispatch(fetchAgreementByIdRequest(params));
    },[agreementId])
  // },1000)

 const agreementData = useSelector(getAgreementByIdState);
 let isNoticeApprove=agreementData?.data?.data?.isNoticeApprove;
 let isApprovedBy=agreementData?.data?.data?.approvedBy;
 let isApprovedTime=agreementData?.data?.data?.approvedTime;


//  var attachments = [
//    { filename:agreementData?.data?.data?.noticeEmailConfirmation?.name , path: agreementData?.data?.data?.noticeEmailConfirmation?.url }, 
//   { filename:agreementData?.data?.data?.noticePeriodDocuments?.name , path: agreementData?.data?.data?.noticePeriodDocuments?.url },];
//  console.log("attachments",attachments,agreementData?.data?.data?.noticePeriodDocuments,agreementData?.data?.data)
 const [userByLocation, setUserByLocation] = useState([]);
 var attachments = [];

 if (agreementData?.data?.data?.noticeEmailConfirmation?.name) {
   attachments.push({ filename:agreementData?.data?.data?.noticeEmailConfirmation?.name , path: agreementData?.data?.data?.noticeEmailConfirmation?.url });
 }
 
 if (agreementData?.data?.data?.noticePeriodDocuments?.name) {
   attachments.push( { filename:agreementData?.data?.data?.noticePeriodDocuments?.name , path: agreementData?.data?.data?.noticePeriodDocuments?.url });
 }
  
  // console.log("agreementData",agreementData?.data?.data?._id)
  let jwtToken = localStorage.getItem(AUTH_TOKEN);
let locationId = agreementData?.data?.data?.location?._id;
  useEffect(async () => {
    await axios
      .get(
        `${BASE_URL}/api/app/subscriber-user/get-users-by-agreement-location?location=${locationId}`,
        {
          headers: {
            token: jwtToken,
          },
        }
      )
      .then((response) => {
        setUserByLocation(response?.data?.data);
      });
  }, [locationId]);
  // const toEmail =  userByLocation?.map((item)=>{return( item?.email)})
  const toEmail2 =  userByLocation?.map((item)=>{return( `${item?.email}` )})
  // const toEmail = userByLocation?.map((item) => `"${item?.email}"`).join(",");
 let fixedEmailArray= ["Finance@sworks.co.in",
]
toEmail2?.map((item)=>{
  fixedEmailArray.push(item)
})
useEffect(()=>{
  dispatch(getUserDetailsRequest({ id: isApprovedBy }));
},[isApprovedBy])
const getuserData = useSelector(getUserDetailData);
//  console.log("user",getuserData)
let name = `${getuserData?.data?.data?.firstName} ${getuserData?.data?.data?.lastName} ${isApprovedTime}`

// console.log("emailData",emailData?.Comment)


  const onClick=()=>{
    let userName= localStorage.getItem('UserName')
    let fromEmails= localStorage.getItem('loggedIN')
    let token= localStorage.getItem('auth_token')
    let userID= localStorage.getItem('user')

    
  
  //   const linkRestData = Object.entries(linkData)
  //   .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  //   .join('&');
  // // Construct the approveLink
  // const approveLink = `${window.location.href.split("/app")[0]}/public/noticeApproval?${linkRestData}?${token}`;
    
  let emailDate = {
       fromEmail: fromEmails,
       toEmail: fixedEmailArray,
       ccEmail: ["pratik.agarwal@sworks.co.in","neetish.sarda@sworks.co.in","yash.karwa@sworks.co.in","rohan.modi@sworks.co.in","techsupport@sworks.co.in"], 
       "attachments":attachments, 
       "dataToBeReplaced":{
         "emailReceiver":"",
    "lockInEndDate": emailData?.lockInEndDate,
    "newTerminationDate":emailData?.newTerminationDate,
    "oldTerminationDate": emailData?.oldTerminationDate,
    "noofSeats": emailData?.noofSeats,
    "clientName": emailData?.clientName,
    "businesCenter":emailData?.businesCenter,
    "clientId": emailData?.clientId,
    "message": emailData?.Comment,
    "initiatedBy": emailData?.initiatedBy,
    "actionedBy": emailData?.actionedBy,
    "approvedBy": userName,
         },
         "templateName":"NoticePeriodApprovalSales-Email"
     };
    dispatch(requestMoveInEmailSend(emailDate))
    dispatch(
      verifySmartSuiteAgreementRequest({
        agreementId: agreementData?.data?.data?._id,
        isNoticeApprove:true,
        approvedBy:userID,
        approvedTime:moment()
      }))
      localStorage.removeItem("NoticeUrl")
      setIsModalVisible(true)
  }
  const handleClose=()=>{
    dispatch(logout());
    setIsModalVisible(false)
  }
  const EmailTemplate = (propss) => {
     let props = propss?.props;
    return (
      <table width="640" cellSpacing="0" cellPadding="0" className="100p" align="center" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td width="640" valign="top" className="100p">
              <div>
                <table width="100%" border="0" cellSpacing="0" cellPadding="20" className="100p brdr" bgcolor="#FFFFFF">
                  <tbody>
                    <tr>
                      <td valign="top">
                        <table border="0" cellSpacing="0" cellPadding="0" width="600" className="100p" background="#ffffff">
                          <tbody>
                            <tr>
                              <td align="center" width="50%" className="100p" style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                                <a href="https://www.smartworksoffice.com/" target="_blank">
                                  <img src="https://s3-ap-southeast-1.amazonaws.com/smartworks-staging/logo.jpg" alt="" />
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table border="0" cellSpacing="0" cellPadding="0" width="600" className="100p" bgcolor="#FFFFFF">
                          <tbody>
                            <tr>
                              <td height="35" style={{ borderTop: '1px solid #666666' }}></td>
                            </tr>
                            <tr>
                              <td align="left" style={{ color: '#1c2a35', fontSize: '16px', paddingBottom: '20px' }}>
                                <font face="'Roboto', Arial, sans-serif">
                                  <span style={{ fontSize: '16px' }}>Hello {props.emailReceiver},</span><br />
                                  <span style={{ fontSize: '16px' }}>
                                    Following agreement is being terminated but the move-out date is before the lock-in is ending.
                                    Hence, you are being intimated and to move further, would require your approval.
                                    Please click on the link to be redirected to the approval page and once the data is validated, please approve the termination from a legal standpoint.
                                    <br /><br /><strong>Client Details</strong>.
                                  </span><br />
                                  <span>Client Name: {props.clientName}</span><br />
                                  <span>Business Center: {props.businesCenter}</span><br />
                                  <span>Number of Seats: {props.noofSeats}</span><br />
                                  <span>Lock-In End Date: {props.lockInEndDate}</span><br />
                                  <span>New Termination Date: {props.newTerminationDate} </span><br />
                                  <span>Comment: {props.Comment} </span><br/>
                                  <span>Actioned By: {props.actionedBy} </span><br /><br />
                                  <span style={{ fontSize: '16px' }}>
                                    <Button style={{ minWidth: "35px", marginRight: "15px",     backgroundColor: agreementData?.data?.data?._id ? "blue" : "rgba(0, 0, 255, 0.5)", // Apply a blurry color if _id is not available
    filter: agreementData?.data?.data?._id ? "none" : "blur(5px)", }}
                    // className="btn btn-primary mr-4"
                    type="primary" disabled={agreementData?.data?.data?._id?false:true} onClick={()=>{
                       onClick()
                                    }
                                    }  target="_blank"><strong> 
                                    {/* {isNoticeApprove?"Already Approved":"Click here to approve."} */}
                                    Click here to approve.
                                    </strong></Button>
                                  </span><br /><br />
                                  <span style={{ fontSize: '16px' }}>Please contact the concerned salesperson in case of any discrepancy.</span><br />
                                  <span style={{ fontSize: '16px' }}><strong>Please note that once approved, it cannot be reverted.</strong>.</span><br /><br />
                                  <span style={{ fontSize: '16px' }}>Best Regards,<br /><strong>Team Smartworks</strong></span>
                                </font>
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style={{ color: '#1c2a35', fontSize: '24px', borderTop: '1px solid #666666', paddingTop: '20px', paddingBottom: '20px' }}>
                                <table width="100%" border="0">
                                  <tbody>
                                    <tr>
                                      <td>
                                        <font face="'Roboto', Arial, sans-serif">
                                          <span style={{ fontSize: '12px', lineHeight: '20px' }}><em>This is a computer-generated mail, please do not reply</em></span>
                                        </font>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        <a href="https://www.facebook.com/smartworksoffice/" target="_blank">
                                          <img src="https://portal.smartworksoffice.com/images/facebook@2x.png" width="42" height="42" alt="" />
                                        </a>
                                        <a href="https://twitter.com/SmartworksInd" target="_blank">
                                          <img src="https://portal.smartworksoffice.com/images/twitter@2x.png" width="42" height="42" alt="" />
                                        </a>
                                        <a href="https://www.linkedin.com/company/smartworks-office/" target="_blank">
                                          <img src="https://portal.smartworksoffice.com/images/linkedin@2x.png" width="42" height="42" alt="" />
                                        </a>
                                        <a href="https://www.instagram.com/smartworksoffice/" target="_blank">
                                          <img src="https://portal.smartworksoffice.com/images/instagram@2x.png" width="42" height="42" alt="" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };
  
  

  
  return (
    <>
      <div>
        {/* chevron */}
        <div
          className="d-flex justify-content-between"
          style={{ height: "80px" }}
        >
        <EmailTemplate props={emailData}/>
          </div>
      </div>

      <CustomizedDialogs
        isModalVisible={isModalVisible}
        handleOkModal={handleClose}
        handleCancelMOdal={handleClose}
        message={"Approved"}
        info={"Thank you"}
      />
{/* 
      <Modal
        title="Accept Proposal"
        visible={isModalAcceptVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Accept"
        cancelText="Cancel"
      >
        <p>Any Comments if you have for us ?</p>
        <TextArea
          rows={4}
          value={acceptNotes}
          onChange={(e) => {
            setAcceptNotes(e.target.value || "");
          }}
        />
      </Modal> */}
    </>
  );
};
export default ApproveNotice;
